<template>
  <b-modal
    size="xlt"
    v-model="show"
    id="add-model"
    title="Find Models"
    centered
    no-close-on-backdrop
    @ok="closeFind()"
    @close="closeFind"
    body-class="find-modal-body"
  >
    <b-tabs align="left" nav-class="filter-tabs">
      <b-tab title="Browse By Category">
        <b-row>
          <b-col
            :cols="isShowingProductModels ? 4 : 12"
            v-show="!isShowingProductModels || !isMobile"
          >
            <order-product-topology
              @showProductModels="toggleProductModels(true)"
              :activeItem = "activeItem"
              :setProductActive = "setProductActive"
              :toggleManufacturingSeriesOpen = "toggleManufacturingSeriesOpen"
              :setManufacturingSeriesActive = "setManufacturingSeriesActive"
              :toggleProductClassOpen = "toggleProductClassOpen"
              :setProductClassActive = "setProductClassActive"
              :topologyTreeLoadding = "topologyTreeLoadding"
              :treeCategories = "treeCategories"
              :getTopology = "getTopology"
            />
          </b-col>
          <b-col :cols="isMobile ? 12 : 8" v-show="isShowingProductModels">
            <order-product-tabs
              @hideProductModels="toggleProductModels(false)"
              :updateTerm="updateTerm"
              :isUsedByRequestSite="isUsedByRequestSite"
              :isUsedByOrdersSite="isUsedByOrdersSite"
              :handleAddItemToOrder="handleAddItemToOrder"
            />
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Search and Filter" v-if="!showTopologyTabOnly">
        <!-- TODO: move to Editor page? -->
        <loading-text v-if="editorSections.length === 0"></loading-text>
        <b-container fluid class="px-0" v-else>
          <b-row no-gutters style="width: 100%; padding-top: 20px">
            <b-col>
              <template v-for="(filter, iFilter) in filters">
                <b-badge
                  variant="light"
                  :key="'badge_' + filter.editorField.EditorFieldId"
                  size="sm"
                  class="mx-1 py-0 w-100"
                >
                  <b-container fluid class="px-0">
                    <b-row no-gutters>
                      <b-col class="col-auto">
                        <b-button
                          v-if="filters.length > 1"
                          size="sm"
                          variant="link"
                          @click.stop="removeFilter(iFilter)"
                        >
                          <b-icon icon="x" variant="danger" />
                        </b-button>
                      </b-col>
                      <b-col cols="12 my-2" md="4" class="px-2">
                        <!-- TODO: search on choice! -->
                        <!-- Then we can do the work -->
                        <b-dropdown
                          block
                          right
                          title="Field"
                          variant="primary"
                          size="sm"
                          menu-class="filter-dropdown"
                        >
                          <template v-slot:button-content>
                            {{ filter.editorField.EntityProperty.selectName }}
                          </template>
                          <b-tabs
                            vertical
                            card
                            pills
                            nav-class="p-1"
                            content-class="mobile-tabs-content"
                          >
                            <template v-for="editorSection in editorSections">
                              <b-tab
                                :title="
                                  editorSection.DisplayName != ''
                                    ? editorSection.DisplayName
                                    : 'Model'
                                "
                                :key="'tab_' + editorSection.EditorSectionId"
                              >
                                <template
                                  v-for="editorField in editorSection.Fields"
                                >
                                  <b-dropdown-item-button
                                    :key="'button_' + editorField.EditorFieldId"
                                    @click="filter.editorField = editorField"
                                    :disabled="
                                      editorField.EntityProperty
                                        .PropertyEntityObject != undefined
                                    "
                                    button-class="mobile-field-dropdown"
                                  >
                                    {{ editorField.DisplayName }}
                                  </b-dropdown-item-button>
                                  <!-- We no longer have this right? -->
                                  <!-- No! We do! it's just the sub! -->
                                  <template
                                    v-if="
                                      editorField.EntityProperty
                                        .PropertyEntityObject
                                    "
                                  >
                                    <template v-if="editorField.PropertyEditor">
                                      <!-- This means we have another list of fields to through -->
                                      <!-- Recursive? -->
                                      <template
                                        v-for="propertySection in editorField
                                          .PropertyEditor.Sections"
                                      >
                                        <template
                                          v-for="propertyEditorField in propertySection.Fields.filter(
                                            (f) =>
                                              f.EditorType !== 'id' &&
                                              f.EditorType !== 'order',
                                          )"
                                        >
                                          <b-dropdown-item-button
                                            :key="
                                              'button_' +
                                              propertyEditorField.EditorFieldId
                                            "
                                            class="ml-2"
                                            @click="
                                              filter.editorField =
                                                propertyEditorField
                                            "
                                            :disabled="
                                              propertyEditorField.EntityProperty
                                                .PropertyEntityObject !=
                                              undefined
                                            "
                                            button-class="mobile-field-dropdown"
                                          >
                                            {{
                                              propertyEditorField.DisplayName
                                            }}
                                          </b-dropdown-item-button>
                                        </template>
                                      </template>
                                    </template>
                                  </template>
                                </template>
                              </b-tab>
                            </template>
                          </b-tabs>
                        </b-dropdown>
                      </b-col>
                      <b-col cols="12 my-2" md="8">
                        <!-- TODO: make based on the EditorType!!! -->
                        <!-- in fact, can't we drop in editor-field? -->
                        <!-- no, because it cares about the obj -->
                        <!-- we could give it a blank Model, but that's cheating eh? -->
                        <!-- or we could have it act differently with no obj -->
                        <!-- or we can have only editor-field care about obj -->
                        <!-- and not the specific field (e.g. checkbox or text)? -->
                        <b-input-group
                          v-if="filter.editorField.EditorType == 'checkbox'"
                        >
                          <b-form-checkbox
                            switch
                            size="sm"
                            class="mx-2 mt-1"
                            v-model="filter.value"
                            @input="searchModelClick()"
                          />
                        </b-input-group>
                        <b-input-group v-else>
                          <b-form-checkbox
                            button
                            size="sm"
                            plain
                            v-model="filter.negate"
                            @input="searchModelClick()"
                            class="mx-2 mt-0"
                            title="Negate"
                          >
                            {{
                              filter.negate ? 'Does not contain' : 'Contains'
                            }}
                          </b-form-checkbox>
                          <b-form-input
                            v-if="!filter.blank"
                            size="sm"
                            autofocus
                            v-model="filter.value"
                            placeholder="Search..."
                            @keyup.enter.native="searchModelClick()"
                            @input="searchModelClick()"
                          />
                          <b-form-input
                            disabled
                            v-if="filter.blank"
                            size="sm"
                            placeholder="[Blank Only]"
                          />
                          <b-form-checkbox
                            switch
                            size="sm"
                            v-model="filter.blank"
                            @input="searchModelClick()"
                            class="ml-2 mt-1"
                            title="Blanks only"
                            >Blank</b-form-checkbox
                          >
                        </b-input-group>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-badge>
              </template>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <br />
              <b-button
                size="sm"
                title="Advanced Model Finder"
                variant="primary"
                @click.stop="addFilter()"
                class="float-left"
              >
                Add Filter
              </b-button>
              <br />
              <br />
            </b-col>
          </b-row>
          <b-row
            no-gutters
            style="width: 100%"
            v-if="modelSearchResults && !modelSearchResults.loading"
          >
            <b-col>
              <template v-if="modelSearchResults.Count > 0">
                <b-table
                  sticky-header="600px"
                  striped
                  hover
                  small
                  bordered
                  :items="modelSearchResults.List"
                  :fields="resultFields"
                  selectable
                  select-mode="single"
                >
                  <template v-slot:head(details)>
                    <div></div>
                  </template>
                  <template v-slot:cell(details)="row">
                    <b-icon
                      :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'"
                      @click="row.toggleDetails"
                    >
                    </b-icon>
                  </template>
                  <template v-slot:cell(actions)="{ item }">
                    <div v-if="isUsedByRequestSite">
                      <b-button
                        v-if="selectedItem !== item.PcnCatalogNumber"
                        size="sm"
                        variant="info background-color-primary"
                        @click.stop="setSearchedPcnCatalogNumber(item.PcnCatalogNumber)"
                        title="Add model to the searching."
                      >
                        <b-icon-check-square aria-hidden="true"></b-icon-check-square>
                      </b-button>
                    </div>
                    <div v-if="isUsedByOrdersSite">
                      <b-button
                        v-if="selectedItem !== item.PcnCatalogNumber"
                        size="sm"
                        variant="info background-color-primary"
                        @click.stop="handleSelectItem(item.PcnCatalogNumber)"
                      >
                        <b-icon-plus-circle
                          aria-hidden="true"
                        ></b-icon-plus-circle>
                      </b-button>
                      <div
                        v-if="
                          showQuantityInput &&
                          selectedItem === item.PcnCatalogNumber
                        "
                      >
                        <b-input-group>
                          <b-form-input
                            class="input-quantity"
                            v-model="quantity"
                            type="number"
                            min="1"
                            size="sm"
                          ></b-form-input>
                          <b-button
                            size="sm"
                            variant="outline-success"
                            @click.stop="handleAddItemToOrder(item, quantity)"
                            ><b-icon icon="check"></b-icon
                          ></b-button>
                          <b-button
                            size="sm"
                            variant="link"
                            @click.stop="selectedItem = ''"
                            ><b-icon icon="x" variant="danger"></b-icon
                          ></b-button>
                        </b-input-group>
                      </div>
                    </div>
                  </template>
                  <template #row-details="row">
                    <b-card class="small">
                      <b-row class="mb-2" v-if="row.item.imgThumbnail">
                        <b-col cols="12">
                          <div class="text-center">
                            <b-img
                              v-if="row.item.imgThumbnail"
                              class="text-center"
                              fluid
                              :src="
                                row.item.imgThumbnail + '?width=100&height=100'
                              "
                            />
                          </div>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col cols="4" class="row-details-label">PCN:</b-col>
                        <b-col cols="8"
                          ><div class="text-left">
                            {{ row.item.PcnCatalogNumber }}
                          </div></b-col
                        >
                      </b-row>
                      <b-row class="mb-2" v-if="row.item.FingoodTpiMfgMod">
                        <b-col cols="4" class="row-details-label"
                          >Model #</b-col
                        >
                        <b-col cols="8 text-left">
                          {{ row.item.FingoodTpiMfgMod }}
                        </b-col>
                      </b-row>
                      <b-row class="mb-2" v-if="row.item.SapModelDescription">
                        <b-col cols="4" class="row-details-label"
                          >Description</b-col
                        >
                        <b-col cols="8 text-left">
                          {{ row.item.SapModelDescription }}
                        </b-col>
                      </b-row>
                      <b-row class="mb-2" v-if="row.item.TotalList">
                        <b-col cols="4" class="row-details-label"
                          >Price</b-col
                        >
                        <b-col cols="8 text-left">
                          {{ row.item.TotalList }}
                        </b-col>
                      </b-row>
                      <b-button
                        size="sm"
                        class="mt-2 w-100"
                        @click="row.toggleDetails"
                        variant="outline"
                        ><b-icon icon="chevron-double-up" variant="link"
                      /></b-button>
                    </b-card>
                  </template>
                </b-table>
                {{ modelSearchResults.Count }} of
                {{ modelSearchResults.Total }} results.
              </template>
              <template v-if="justOpened">
                <b>Use the filters to search and filter the results.</b>
              </template>
              <template
                v-else-if="
                  modelSearchResults &&
                  !modelSearchResults.loading &&
                  modelSearchResults.Count == 0
                "
              >
                <b>No Models Found for the filters.</b>
              </template>
            </b-col>
          </b-row>
          <b-row
            no-gutters
            style="width: 100%"
            v-else-if="modelSearchResults && modelSearchResults.loading"
          >
            <b-col> Loading... </b-col>
          </b-row>
        </b-container>
      </b-tab>
      <b-tab title="Configurable Material" v-if="false &&!showConfigurableMaterials">
        <b-row class="m-5">
          <div class="col-md-11">
            <multiselect
              v-model="configurableMaterial"
              :options="configurableMaterials"
              placeholder="Select a configurable material"
              track-by="PcnCatalogNumber"
              label="PcnCatalogNumber"
            >
            </multiselect>
          </div>
          <div class="col-md-1">
            <b-button
              size="sm"
              variant="outline-success"
              @click.stop="handleAddItemToOrder(configurableMaterial, 1)"
              ><b-icon icon="check"></b-icon
            >Add</b-button>
          </div>
        </b-row>
      </b-tab>
    </b-tabs>
    <template v-slot:modal-footer="{}">
      <b-button
        size="sm"
        variant="secondary"
        @click="closeFind()"
        class="float-right"
      >
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script lang="ts">
import { Component, Prop, Watch } from 'vue-property-decorator'

import ModelEditor from '@/components/editor/modals/model-editor.vue'
import StatusBadge from '@/components/editor/status-badge.vue'
import EditorEditor from '@/components/editor/utility/editor-editor.vue'
import LoadingText from '@/components/utility/loading-text.vue'

import { namespace } from 'vuex-class'

import { Model, ModelFilter } from '@/store/editor-model/types'

import MxSite from '@/mixins/site'
import { blankEditorField } from '@/store/entity/constants'
import { EditorLookup } from '@/store/entity/types'
import { ResponseArray } from '@/store/types'
import OrderProductTabs from './order-product-tabs.vue'
import OrderProductTopology from './order-product-topology.vue'
import { isMobile, handleResize } from '@/common/helpers/responsive-helper'
import { Category, ActiveCategory } from '@/store/editor/types'
import { CartItem } from '@/store/cart/types'
import Multiselect from 'vue-multiselect'

const nsEntity = namespace('entity')
const nsModelFinder = namespace('model-finder')
const nsProductFinder = namespace('product-finder')
const nsCart = namespace('cart')
const nsMultiplier = namespace('multiplier')
const nsConfigurableMaterial = namespace('configurable-material')

@Component({
  components: {
    'loading-text': LoadingText,
    'editor-editor': EditorEditor,
    'status-badge': StatusBadge,
    'model-editor': ModelEditor,
    'order-product-topology': OrderProductTopology,
    'order-product-tabs': OrderProductTabs,
    Multiselect,
  },
})
export default class extends MxSite {
  public changed = false
  public valid = true
  private catalogNumber = ''
  public show = false
  public justOpened = true
  public quantity = 1
  public showQuantityInput = false
  public selectedItem = ''
  public filters: ModelFilter[] = []
  public isMobile = isMobile()

  @Prop()
  private findingModel!: boolean

  @Prop()
  public exists!: (model: Model) => Promise<boolean>

  @Prop()
  public isUsedByOrdersSite!: false

  @Prop()
  public isUsedByRequestSite!: false

  @nsProductFinder.Action('setProductClassActive')
  private setProductClassActive!: any

  @nsProductFinder.Action('toggleProductClassOpen')
  public toggleProductClassOpen!: any

  @nsProductFinder.Action('setProductActive')
  private setProductActive!: any

  @nsProductFinder.State('activeItem')
  public activeItem!: ActiveCategory

  @nsProductFinder.Action('setManufacturingSeriesActive')
  private setManufacturingSeriesActive!: any

  @nsProductFinder.Action('toggleManufacturingSeriesOpen')
  public toggleManufacturingSeriesOpen!: any

  @nsModelFinder.Action('toggleProductModels')
  public toggleProductModels: any

  @nsProductFinder.State('topologyTreeLoadding')
  public topologyTreeLoadding!: boolean

  @nsProductFinder.State('treeCategories')
  public treeCategories!: Category[]

  @nsProductFinder.Action('getTopology')
  public getTopology: any

  @nsModelFinder.Mutation('addRecentlySearchedPcn')
  private addRecentlySearchedPcn: any

  @nsModelFinder.State('modelSearchResults')
  public modelSearchResults!: ResponseArray<Model>

  @nsModelFinder.Mutation('modelSearchResultsBlank')
  private modelSearchResultsBlank: any

  @nsEntity.State('editorLookup')
  public editorLookup!: EditorLookup

  @nsModelFinder.State('isShowingProductModels')
  public isShowingProductModels!: any

  @nsModelFinder.Action('resetCategoriesOpen')
  private resetCategoriesOpen: any

  @nsModelFinder.Mutation('updateTerm')
  private updateTerm: any

  @nsModelFinder.Action('findModel')
  private findModel: any

  @nsCart.Action('saveCartItem')
  private saveCartItem: any

  @Prop()
  private showTopologyTabOnly!: boolean

  @Prop({ default: false })
  private showConfigurableMaterials!: boolean

  @nsMultiplier.Getter('getMultiplierPrice')
  private getMultiplierPrice: any

  @nsConfigurableMaterial.Action('fetchConfigurableMaterials')
  private fetchConfigurableMaterials: any

  @nsConfigurableMaterial.Getter('configurableMaterials')
  public configurableMaterials: any

  public configurableMaterial: any = null

  public created() {
    handleResize((isMobile) => {
      this.isMobile = isMobile
    })
  }

  public mounted() {
    this.fetchConfigurableMaterials()
  }

  public resultFields = [
    {
      key: 'details',
      label: 'Toggle Details',
      thClass: 'responsive-col-hide text-left',
      tdClass: 'responsive-col-hide text-left',
      thStyle: { width: '10%' },
    },
    {
      key: 'PcnCatalogNumber',
      label: 'Catalog Number',
      class: 'px-2',
      thClass: 'responsive-col-size text-left',
      tdClass: 'responsive-col-size text-left',
      thStyle: 'resp-th-30',
      sortable: true,
    },
    {
      key: 'FingoodTpiMfgMod',
      label: 'Model Number',
      thClass: 'responsive-col text-left',
      tdClass: 'responsive-col text-left',
      class: 'px-2',
      thStyle: 'resp-th-30',
      sortable: false,
    },
    {
      key: 'SapModelDescription',
      label: 'Sap Model Description',
      class: 'px-2',
      thClass: 'responsive-col text-left',
      tdClass: 'responsive-col text-left',
      sortable: false,
    },
    {
      key: 'TotalList',
      label: 'Price',
      class: 'px-2',
      sortable: false,
      thClass: 'responsive-col-size text-left',
      tdClass: 'responsive-col-size text-left',
      thStyle: 'resp-th-30',
      formatter: (val: any) => {
        if (val == null) {
          return ''
        } else if (isNaN(val)) {
          return val
        } else {
          return `$${parseFloat(val).toFixed(2)}`
        }
      },
    },
    {
      key: 'actions',
      label: 'actions',
      thClass: 'responsive-col text-left',
      class: 'px-2 text-center',
      sortable: true,
    },
  ]

  private searchTimeout = setTimeout(() => {
    return false
  }, 0)

  @Watch('findingModel')
  private async setShowModal() {
    this.show = this.findingModel
    if (this.show && this.editorSections.length === 0 && !this.showTopologyTabOnly) {
      await this.$store.dispatch('entity/preload', { root: true })
      this.catalogNumber = ''
      this.modelSearchResultsBlank()
    }
  }

  @Watch('editorSections')
  private setPcnField() {
    if (this.filters.length > 0) {
      return
    }
    const pcnField = this.editorSections[0].Fields.find(f => f.EntityPropertyName === 'PCN_CATALOGNUMBER')
    if (pcnField) {
      this.filters.push({
        editorField: pcnField,
        value: '',
        blank: false,
        negate: false,
      })
    }
  }

  public closeFind() {
    this.justOpened = true
    this.catalogNumber = ''
    this.show = false
    this.$emit('close', false)
    this.resetCategoriesOpen()
  }

  public findModelInternal() {
    this.justOpened = false
    const { catalogNumber, filters } = this
    // if any of the filters are blank, don't do a search
    if (
      filters.some((filter) => filter.editorField.EditorFieldId === -1) ||
      filters[0].value === ''
    ) {
      return
    }
    this.addRecentlySearchedPcn(catalogNumber)
    this.findModel({ catalogNumber, filters }).then(() => {
      //
    })
  }

  public searchModelClick() {
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => {
      this.findModelInternal()
    }, 1000)
    //
  }

  public async handleAddItemToOrder(item: Model, quantity: number) {
    item.TotalList = item.TotalList ?? 0
    const price = this.getMultiplierPrice(item.PcnCatalogNumber, item.ProductHierarchy, item.TotalList)
    const cartItem: CartItem = {
      pcnCatalogNumber: item.PcnCatalogNumber || '',
      productHierarchy: item.ProductHierarchy || '',
      fingoodTpiMfgMod: item.FingoodTpiMfgMod || '',
      description:
        item.SapModelDescription || item.Details.Description?.toString() || '',
      originalPrice: parseFloat(item.TotalList.toString()) || 0,
      price: price || 0,
      totalPrice: price * parseInt(quantity.toString()),
      quantity: parseInt(quantity.toString()),
      imgThumbnail: item.Image?.ImagePath || '',
      inventory: item.Available,
      modelDetails: item.Details,
      leadTime: item.LeadTime || 0,
      configurable: item.Configurable,
    }
    // check for valid price
    this.saveCartItem({ cartItem })
      .then(() => {
        this.toastSuccess('Item Added to Order')
      })
      .catch(() => {
        this.toastError('Fail to add item to Order')
      })
    this.selectedItem = ''
  }

  get hasAdd() {
    return this.$listeners.addModel !== undefined
  }

  // TODO: we didn't bring these over with us!
  // - so we do need the Editor stuffs!
  get editorSections() {
    return this.editorLookup.model.Sections.filter(
      (s) =>
        s.EditorSectionName !== 'Divisions' &&
        s.EditorSectionName !== 'Dimensions' &&
        s.EditorSectionName !== 'Labels' &&
        s.EditorSectionName !== 'Associations' &&
        s.EditorSectionName !== 'Model Associations' &&
        s.EditorSectionName !== 'Model Image',
    )
  }

  public addFilter() {
    // if we already have a blank one, don't do it!
    if (this.filters.some((f) => f.editorField.EditorFieldId === -1)) {
      return
    }

    this.filters.push({
      editorField: blankEditorField,
      value: '',
      blank: false,
      negate: false,
    })
  }

  public removeFilter(i: number) {
    this.filters.splice(i, 1)
    this.searchModelClick()
  }

  public handleSelectItem(pcnCatalogNumber: string) {
    this.showQuantityInput = true
    this.quantity = 1
    this.selectedItem = pcnCatalogNumber
  }

  public setSearchedPcnCatalogNumber(pcnCatalogNumber: string) {
    this.updateTerm(pcnCatalogNumber)
    this.toastSuccess('Model ' + pcnCatalogNumber + ' selected')
  }
}
</script>
<style>
.find-modal-body {
  min-height: 300px;
}
.filter-dropdown {
  min-width: 600px !important;
  /* height: 200px!important; */
  /* overflow: auto; */
}
.filter-tab {
  overflow: auto;
  height: 350px !important;
}
.modal-dialog {
  max-width: 90% !important;
}

.input-quantity {
  width: 30px !important;
  text-align: center;
}

.mobile-tabs-content {
  height: 50vh;
  overflow: auto;
}

@media (max-width: 767px) {
  .category-browser {
    display: none;
  }
  .filter-dropdown {
    min-width: 100vw !important;
  }
  .mobile-field-dropdown {
    text-wrap: balance !important;
    line-height: initial !important;
    min-width: 40vw !important;
  }
}
</style>
